const DYNAMO_DOG_URL = "https://dynamo.dog"

export function shareCardTitle(dogName: string, archetypeLabel: string): string {
  return `${dogName} is ${archetypeLabel}`
}

export function shareCardText(shareUrl?: string | null): string {
  const destination = shareUrl || DYNAMO_DOG_URL
  return `Discover your dog's personality at ${destination}`
}

/** Prefer URL-only Web Share when a share URL is available. */
export function shouldPreferUrlShare(shareUrl: string | null | undefined): boolean {
  return Boolean(shareUrl)
}

export { DYNAMO_DOG_URL }
